var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-shadow fixed inset-0 transition-background ease-in-out duration-200 h-screen overflow-y-hidden",class:{ 'pointer-events-none': !_vm.show }})
}
var staticRenderFns = []

export { render, staticRenderFns }